// @flow
import * as React from 'react';
import {
  useAppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherAgentMutation,
} from '../../../../../../shared';
import { useConfirm } from '@coverright/features';
import { theme } from '../../../../../../app/theme';
import { MenuItem } from '@mui/material';


export const ArAgentConfirmationToggleReAssignOption = ({id, onClick}: {id: string, onClick: () => void}) => {
  const [request] = useAppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherAgentMutation({
    variables: {id}
  })
  const confirm = useConfirm(theme);

  const handleClick = () => confirm({
    title: 'Confirmation',
    content: 'Do you want to re-assign this client to another available agent?',
    okButtonTitle: 'Yes',
    cancelButtonTitle: 'No',
    width: 500
  }).then(val => {
    if (val) {
      request();
    }
  })

  return (
    <MenuItem onClick={() => {
      onClick();
      handleClick();
    }}>Re-assign to another agent</MenuItem>
  );
};
